import { inject, Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Observable } from 'rxjs'
import { environment } from '@environments/environment'
import { CompanyExtractionResponse } from '@shared/models/company-extraction.model'

@Injectable({
  providedIn: 'root'
})
export class AiService {
  private readonly http = inject(HttpClient)
  private readonly apiUrl = environment.certificateApiUrl

  /**
   * Until the customer provides the ai-service, the backend offers a mock that always answers with the same
   * companies, whatever the text.
   */
  public extractCompanies(text: string): Observable<CompanyExtractionResponse> {
    return this.http.post<CompanyExtractionResponse>(`${this.apiUrl}/euat-mock`, text, {
      headers: new HttpHeaders({ 'Content-Type': 'text/plain' })
    })
  }
}
